import React from 'react';
import styled from 'styled-components';

const Headings = ({ headingName }) => {
  return (
    <PageBanner>
      <BannerOverlay />
      <BannerContent>
        <BreadCrumb>Home / {headingName}</BreadCrumb>
        <PageTitle>{headingName}</PageTitle>
        <GoldBar />
      </BannerContent>
    </PageBanner>
  );
};

const PageBanner = styled.div`
  position: relative;
  background: #111827;
  padding: 72px 32px 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  &::before {
    content: '';
    position: absolute;
    inset: 0;
    background: repeating-linear-gradient(
      -45deg,
      transparent,
      transparent 20px,
      rgba(255, 255, 255, 0.015) 20px,
      rgba(255, 255, 255, 0.015) 40px
    );
  }
`;

const BannerOverlay = styled.div`
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 6px;
  background: #c89432;
`;

const BannerContent = styled.div`
  position: relative;
  z-index: 1;
  text-align: center;
`;

const BreadCrumb = styled.p`
  font-family: "Poppins", sans-serif;
  font-size: 0.75rem;
  font-weight: 500;
  letter-spacing: 2px;
  text-transform: uppercase;
  color: #c89432;
  margin-bottom: 12px;
`;

const PageTitle = styled.h1`
  font-family: "Poppins", sans-serif;
  font-size: clamp(2rem, 4vw, 3rem);
  font-weight: 700;
  color: #fff;
  letter-spacing: 1px;
  margin-bottom: 20px;
`;

const GoldBar = styled.div`
  width: 56px;
  height: 4px;
  background: #c89432;
  border-radius: 2px;
  margin: 0 auto;
`;

export default Headings;
